"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var settings_1 = require("../../../shared/settings");
var defaultSettings = {
    failureTreshold: 0.9,
    minimumSamples: 9,
    maximumSamples: 10,
    maxTimeForHalfOpenRequest: 5000,
    openDuration: 5000,
    samplingDuration: 5000,
    timeout: 10000,
};
var HttpApiSettings = /** @class */ (function (_super) {
    __extends(HttpApiSettings, _super);
    function HttpApiSettings(_a) {
        var config = _a.config, circuitBreakerHash = _a.circuitBreakerHash, assertStatusCode = _a.assertStatusCode;
        return _super.call(this, { config: config, target: 'browser', circuitBreakerHash: circuitBreakerHash, assertStatusCode: assertStatusCode, defaultSettings: defaultSettings }) || this;
    }
    return HttpApiSettings;
}(settings_1.HttpApiSettingsBase));
exports.HttpApiSettings = HttpApiSettings;
//# sourceMappingURL=httpApiSettings.js.map